import React, { useEffect, useState } from "react";

// One-time brand splash: white screen with the CARMAPS wordmark + pulsing green
// dot, then a curtain that lifts to reveal the site. Shown once per session and
// disabled under prefers-reduced-motion. StrictMode-safe (the "seen" flag is
// written only when the intro actually completes).
let introCompleted = false;

export default function Intro() {
  const [phase, setPhase] = useState("show"); // show | exit | done
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) { setPhase("done"); return undefined; }
    if (introCompleted) { setPhase("done"); return undefined; }
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced || sessionStorage.getItem("cm_intro_seen") === "1") {
      introCompleted = true;
      setPhase("done");
      return undefined;
    }
    setActive(true);
    document.body.style.overflow = "hidden";
    const t1 = setTimeout(() => setPhase("exit"), 1150);
    const t2 = setTimeout(() => {
      introCompleted = true;
      sessionStorage.setItem("cm_intro_seen", "1");
      document.body.style.overflow = "";
      setPhase("done");
    }, 1900);
    return () => { clearTimeout(t1); clearTimeout(t2); document.body.style.overflow = ""; };
  }, []);

  if (phase === "done" || !active) return null;
  return (
    <div className={`cm-intro${phase === "exit" ? " cm-intro-exit" : ""}`} aria-hidden="true" data-testid="intro-splash">
      <div className="cm-intro-brand">
        <span className="cm-intro-word">CARMAPS</span>
        <span className="cm-intro-dot" />
      </div>
    </div>
  );
}
